module.exports = __webpack_public_path__ + "static/img/组 2890.1ec8d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/agency/images/组 2890.png
// module id = CJvZ
// module chunks = 0